module.exports = "/assets/dist/images/bodystyles_hatchbacks_sm.png?5dba97642898b2b2c3633c54af658863";